module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_FI-d2708305255ab590c97055b15c1c9197.svg";